import React from 'react';
import StackManager from '../components/supplements/StackManager';
import SupplementQuiz from '../components/supplements/SupplementQuiz';

// The Supplements hub. Discover (the honesty-first goal quiz, SS4) → manage (your
// standing stack, SS1). The quiz drives the same deterministic, safety-gated SS3
// engine; profile-tied suggestions also live on /you. Anonymous visitors get the
// same quiz at the public /quiz route.

const SupplementsPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          Supplements
        </h1>
        <p className="mt-2 text-base text-stone-600 dark:text-stone-300">
          Your stack, kept honest — what you take, what the evidence says, and what
          you could get from food instead.
        </p>
      </div>

      <SupplementQuiz
        heading="Not sure where to start?"
        subheading="Answer a couple of questions and get honest, evidence-graded suggestions — including when food does the job or you can skip it."
        showSignupCta={false}
      />
      <StackManager />
    </div>
  );
};

export default SupplementsPage;
